import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export async function getRetry(url, tries = 3) {
  let lastErr;
  for (let i = 0; i < tries; i++) {
    try { return await api.get(url); }
    catch (e) {
      const s = e?.response?.status;
      if (s && s < 500) throw e;
      lastErr = e;
      if (i < tries - 1) await new Promise((r) => setTimeout(r, 700 * (i + 1)));
    }
  }
  throw lastErr;
}

const CHUNK_SIZE = 4 * 1024 * 1024;

export async function uploadVideoChunked(file, onProgress) {
  const { data: init } = await api.post("/admin/upload/video/init", {
    filename: file.name, content_type: file.type || "video/mp4", total_size: file.size,
  });
  const total = Math.max(1, Math.ceil(file.size / CHUNK_SIZE));
  for (let i = 0; i < total; i++) {
    const blob = file.slice(i * CHUNK_SIZE, Math.min(file.size, (i + 1) * CHUNK_SIZE));
    const fd = new FormData();
    fd.append("upload_id", init.upload_id);
    fd.append("index", i);
    fd.append("chunk", blob, "chunk");
    let lastErr;
    for (let attempt = 0; attempt < 3; attempt++) {
      try {
        await api.post("/admin/upload/video/chunk", fd, {
          onUploadProgress: (p) => onProgress && onProgress(Math.min(99, Math.round(((i * CHUNK_SIZE + p.loaded) / file.size) * 100))),
        });
        lastErr = null;
        break;
      } catch (e) {
        lastErr = e;
        if (e?.response?.status && e.response.status < 500 && e.response.status !== 413) throw e;
        await new Promise((r) => setTimeout(r, 800 * (attempt + 1)));
      }
    }
    if (lastErr) throw lastErr;
  }
  const { data } = await api.post("/admin/upload/video/complete", { upload_id: init.upload_id });
  if (onProgress) onProgress(100);
  return data;
}

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").join(" ");
  return e?.message || "Something went wrong";
}

export function fmtPrice(usd, currency) {
  if (usd === 0) return "Free";
  if (currency === "EUR") return `€${(usd * 0.92).toFixed(2)}`;
  return `$${usd.toFixed(2)}`;
}

export function fmtDuration(min) {
  const h = Math.floor(min / 60);
  const m = min % 60;
  return h ? `${h}h ${m}m` : `${m}m`;
}

export function mediaUrl(url) {
  if (!url) return url;
  if (url.startsWith("/api/")) return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  return url;
}
